import React from 'react';
import { ChevronRight } from 'lucide-react';

/**
 * Reusable menu item component for the mobile slide-over menu
 * 
 * @param {React.ReactNode} icon - Icon component to display
 * @param {string} label - Text label for the menu item
 * @param {function} onClick - Click handler
 * @param {boolean} chevron - Whether to show a right chevron (for navigation)
 * @param {number|string|null} badge - Optional badge content (e.g. count)
 */
const MobileMenuItem = ({ icon, label, onClick, chevron = false, badge = null }) => {
  return (
    <button
      onClick={onClick}
      className="w-full flex items-center justify-between p-3 rounded-lg text-white hover:bg-slate-800 active:bg-slate-700 transition-colors active:scale-98 mb-2"
    >
      <div className="flex items-center gap-3">
        <div className="flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-full bg-slate-800/90 text-emerald-400">
          {icon}
        </div>
        <span className="text-base">{label}</span>
      </div>
      
      <div className="flex items-center gap-2">
        {badge !== null && (
          <span className="px-2 py-0.5 text-xs font-medium bg-emerald-700 text-emerald-100 rounded-full">
            {badge}
          </span>
        )}
        
        {chevron && (
          <ChevronRight className="w-5 h-5 text-slate-400" />
        )}
      </div>
    </button>
  );
};

export default MobileMenuItem;